import SpinnerComponent from './SpinnerComponent';

export default SpinnerComponent